import { gql } from '@apollo/client';
import { META_DATA_QUERY_FIELDS } from 'src/graphql/entities/metadata.fragments';
import { SUPPORT_POLICY_FIELDS, SUPPORT_POLICY_RELATIONS } from './support-policy.fragments';

export const GET_SUPPORT_POLICY_QUERY = gql`
  query GetSupportPolicy($params: QueryParams, $skipTotalRecords: Boolean = false) {
    getSupportPolicy(queryParams: $params) {
      records {
        ...SupportPolicyFields
        ...SupportPolicyRelations
      }
      metadata {
        ...MetaDataQueryFields
      }
    }
  }
  ${SUPPORT_POLICY_FIELDS}
  ${SUPPORT_POLICY_RELATIONS}
  ${META_DATA_QUERY_FIELDS}
`;

export const CREATE_SUPPORT_POLICY_MUTATION = gql`
  mutation CreateSupportPolicyWithGroups($data: CreateSupportPolicyWithGroupsInput!) {
    createSupportPolicyWithGroups(data: $data) {
      ...SupportPolicyFields
    }
  }
  ${SUPPORT_POLICY_FIELDS}
`;

export const DELETE_SUPPORT_POLICY_MUTATION = gql`
  mutation DeleteSupportPolicy($conditions: [ConditionInput]) {
    deleteSupportPolicy(conditions: $conditions) {
      id
    }
  }
`;

export const DELETE_SUPPORT_POLICY_TO_USER_GROUPS_MUTATION = gql`
  mutation DeleteSupportPolicyToUserGroup($conditions: [ConditionInput]) {
    deleteSupportPolicyToUserGroup(conditions: $conditions) {
      id
    }
  }
`;

export const UPDATE_SUPPORT_POLICY_WITH_GROUPS_MUTATION = gql`
  mutation UpdateSupportPolicyWithGroups($data: UpdateSupportPolicyWithGroupsInput!) {
    updateSupportPolicyWithGroups(data: $data) {
      ...SupportPolicyFields
    }
  }
  ${SUPPORT_POLICY_FIELDS}
`;

export const UPDATE_SUPPORT_POLICY_MUTATION = gql`
  mutation UpdateSupportPolicy($conditions: [ConditionInput], $data: SupportPolicyDataInput) {
    updateSupportPolicy(conditions: $conditions, data: $data) {
      ...SupportPolicyFields
    }
  }
  ${SUPPORT_POLICY_FIELDS}
`;
